import { writeBrowserHistory } from '../browserHistory'
import { GLOBAL_PROJECT_ID } from '../../components/AdminPanel/Assistants/assistantsHelper'
import ProjectHelper from '../../components/SettingsView/ProjectsSettings/ProjectHelper'
import URLSystem from '../URLSystem'

/**
 * /projects/{projectId}/assistants/{assistantId}
 */
export const URL_ASSISTANT_DETAILS = 'ASSISTANT_DETAILS'

/**
 * /projects/{projectId}/assistants/{assistantId}/customizations
 */
export const URL_ASSISTANT_DETAILS_CUSTOMIZATIONS = 'ASSISTANT_DETAILS_CUSTOMIZATIONS'

/**
 * /projects/{projectId}/assistants/{assistantId}/workflow
 */
export const URL_ASSISTANT_DETAILS_WORKFLOW = 'ASSISTANT_DETAILS_WORKFLOW'

/**
 * /projects/{projectId}/assistants/{assistantId}/backlinks/tasks
 */
export const URL_ASSISTANT_DETAILS_BACKLINKS_TASKS = 'ASSISTANT_DETAILS_BACKLINKS_TASKS'

/**
 * /projects/{projectId}/assistants/{assistantId}/backlinks/notes
 */
export const URL_ASSISTANT_DETAILS_BACKLINKS_NOTES = 'ASSISTANT_DETAILS_BACKLINKS_NOTES'

/**
 * /projects/{projectId}/assistants/{assistantId}/note
 */
export const URL_ASSISTANT_DETAILS_NOTE = 'ASSISTANT_DETAILS_NOTE'

/**
 * /projects/{projectId}/assistants/{assistantId}/chat
 */
export const URL_ASSISTANT_DETAILS_CHAT = 'ASSISTANT_DETAILS_CHAT'

/**
 * /projects/{projectId}/assistants/{assistantId}/updates
 */
export const URL_ASSISTANT_DETAILS_UPDATES = 'ASSISTANT_DETAILS_UPDATES'

/**
 * URL System for Aissistants
 */
class URLsAssistants {
    /**
     * Replace the history url
     * @param urlConstant
     * @param data
     * @param params
     */
    static replace = (urlConstant, data = null, ...params) => {
        let urlPath = URLsAssistants.getPath(urlConstant, ...params)

        URLSystem.setLastNavigationScreen(urlPath, true)

        writeBrowserHistory('replace', data, urlPath, () => URLsAssistants.setTitle(urlConstant, false, ...params))
    }

    /**
     * Push a new state into the history url
     * @param urlConstant
     * @param data
     * @param params
     */
    static push = (urlConstant, data = null, ...params) => {
        let urlPath = URLsAssistants.getPath(urlConstant, ...params)

        URLSystem.setLastNavigationScreen(urlPath)

        writeBrowserHistory('push', data, urlPath, () => URLsAssistants.setTitle(urlConstant, false, ...params))
    }

    static getPath = (urlConstant, ...params) => {
        switch (urlConstant) {
            case URL_ASSISTANT_DETAILS:
                return `projects/${params[0]}/assistants/${params[1]}`
            case URL_ASSISTANT_DETAILS_CUSTOMIZATIONS:
                return `projects/${params[0]}/assistants/${params[1]}/customizations`
            case URL_ASSISTANT_DETAILS_WORKFLOW:
                return `projects/${params[0]}/assistants/${params[1]}/workflow`
            case URL_ASSISTANT_DETAILS_BACKLINKS_TASKS:
                return `projects/${params[0]}/assistants/${params[1]}/backlinks/tasks`
            case URL_ASSISTANT_DETAILS_BACKLINKS_NOTES:
                return `projects/${params[0]}/assistants/${params[1]}/backlinks/notes`
            case URL_ASSISTANT_DETAILS_NOTE:
                return `projects/${params[0]}/assistants/${params[1]}/note`
            case URL_ASSISTANT_DETAILS_CHAT:
                return `projects/${params[0]}/assistants/${params[1]}/chat`
            case URL_ASSISTANT_DETAILS_UPDATES:
                return `projects/${params[0]}/assistants/${params[1]}/updates`
        }
    }

    static setTitle = (urlConstant, internal = false, ...params) => {
        const projectId = params[0]
        // Use the loaded project like the other object routes. A delayed
        // Firestore read can leave the previous object's title on this entry
        // or overwrite the next view's title after navigating away.
        const projectName =
            projectId === GLOBAL_PROJECT_ID ? 'Admin' : ProjectHelper.getProjectNameById(projectId, 'Project')

        const prefix = internal ? '' : 'Alldone.app - '
        let title = ''

        const assistantDetails = (titleSuffix = '') => {
            title = `${prefix}${projectName} - Assistant details${titleSuffix}`
        }

        switch (urlConstant) {
            case URL_ASSISTANT_DETAILS: {
                assistantDetails()
                break
            }
            case URL_ASSISTANT_DETAILS_CUSTOMIZATIONS: {
                assistantDetails(' - Customizations')
                break
            }
            case URL_ASSISTANT_DETAILS_WORKFLOW: {
                assistantDetails(' - Workflow')
                break
            }
            case URL_ASSISTANT_DETAILS_BACKLINKS_TASKS: {
                assistantDetails(' - Linked tasks')
                break
            }
            case URL_ASSISTANT_DETAILS_BACKLINKS_NOTES: {
                assistantDetails(' - Linked notes')
                break
            }
            case URL_ASSISTANT_DETAILS_NOTE: {
                assistantDetails(' - Note')
                break
            }
            case URL_ASSISTANT_DETAILS_CHAT: {
                assistantDetails(' - Chat')
                break
            }
            case URL_ASSISTANT_DETAILS_UPDATES: {
                assistantDetails(' - Updates')
                break
            }
        }

        !internal && (document.title = title)
        return title
    }
}

export default URLsAssistants
